function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m422 0v30h-332v-30h-90v271h90v-30h332v30h90v-271zm-362 241h-30v-211h30zm30-181h135.287l-38.832 49.813 73.541 55.33-15.44 45.857h-154.556zm186.211 151 19.126-56.809-66.459-50.004 34.448-44.187h158.674v151zm205.789 30h-30v-211h30z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m264.612 346.605c0-14.32-5.577-27.783-15.703-37.909l-37.909-37.909-37.909 37.909c-10.126 10.126-15.703 23.589-15.703 37.909 0 29.562 24.05 53.612 53.612 53.612s53.612-24.05 53.612-53.612zm-53.612 23.613c-13.02 0-23.612-10.593-23.612-23.612 0-6.307 2.456-12.236 6.916-16.696l16.696-16.697 16.696 16.696c4.459 4.46 6.916 10.39 6.916 16.696 0 13.02-10.592 23.613-23.612 23.613z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m301 382.569-37.909 37.909c-10.126 10.126-15.703 23.589-15.703 37.909 0 29.562 24.05 53.612 53.612 53.612s53.612-24.051 53.612-53.612c0-14.32-5.577-27.783-15.703-37.909zm0 99.431c-13.02 0-23.612-10.593-23.612-23.612 0-6.307 2.456-12.236 6.916-16.696l16.696-16.697 16.696 16.696c4.459 4.46 6.916 10.39 6.916 16.696 0 13.02-10.592 23.613-23.612 23.613z"
}));

function Svg46(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "inherit",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg46);
export default __webpack_public_path__ + "static/media/4_6.bee61c1a.svg";
export { ForwardRef as ReactComponent };